import React, { useEffect, useState } from 'react';
import { Modal, AutoComplete, DatePicker, Input, Tooltip } from 'antd';
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { BroadcastMergeChunk, fileKeyUpdate, postBroadcastVideoUpload, updatepdf, uploadBroadcastBlock ,setHideMsgTrue, deleteBroadcastRecording, setRecordingsData} from 'actions/broadcast';
import { setCardData } from 'actions/schedule';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from "uuid";
import file_image_1 from '../../../Assets/images/file_image_1.svg'
import { Button } from 'components/Button';
import { EventRegister } from 'react-native-event-listeners';
import { Notification } from 'services';


import { uploadFileInChunks } from 'services/chunkedUpload';
import { getLocalVideoDurationSec } from 'services/localVideoDuration';
import { saveReplacedRecording } from 'services/recordingStorage';

const { Dragger } = Upload;


const ReplaceVideos = ({ isUploadModal, setIsUploadModal, setRecordingsModalVisibility, roomName, deleteBroadcastRecording=false, BroadcastMergeChunk, fileKeyUpdate, updatepdf, uploadBroadcastBlock, Pdftoupload, postBroadcastVideoUpload ,setHideMsgTrue, isupload=false, cardData, setCardData, recordingsData, setRecordingsData}) => {
    const [duration, setDuration] = useState(null);
    const [fileSize, setFileSize] = useState(null);
    const [loader, setLoader] = useState(false);
    const [videoFile, setVideoFile] = useState(null);
    const [progress, setProgress] = useState(0);

    let uploadingMessage;

    const handleOK = () => {
        setLoader(true);
        setHideMsgTrue(true);
        const proceedWithUpload = () => {
            uploadFunction(uploadingMessage, () => { }, () => {});
        };

        if (typeof deleteBroadcastRecording === 'function') {
            // Best-effort cleanup of any existing broadcast recording on media server before uploading replacement;
            // suppress error toast and proceed with upload regardless of whether old mp4 existed
            deleteBroadcastRecording(roomName, proceedWithUpload, null, true);
        } else {
            proceedWithUpload();
        }
    };

    useEffect(() => {
        fileKeyUpdate('');
    }, []);

    const handleCancel = () => {
        setIsUploadModal(false);
        setVideoFile(null);
        setFileSize(null);
        setDuration(null);
        if (setRecordingsModalVisibility) {
            setRecordingsModalVisibility(true);
        }
    };

    const formatDuration = (durationInSeconds) => {
        const sec = Math.max(0, Math.round(durationInSeconds));
        const hours = Math.floor(sec / 3600);
        const minutes = Math.floor((sec % 3600) / 60);
        const seconds = Math.floor(sec % 60);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const extractFileInfo = (file) => {
        if (!file) return;
        if (file.size) {
            setFileSize(file.size);
        }
        getLocalVideoDurationSec(file)
            .then((seconds) => {
                if (seconds > 0) {
                    setDuration(formatDuration(seconds));
                }
            })
            .catch(() => {
                try {
                    const video = document.createElement('video');
                    video.preload = 'metadata';
                    video.onloadedmetadata = function () {
                        if (video.duration && isFinite(video.duration)) {
                            setDuration(formatDuration(video.duration));
                            if (file.size) setFileSize(file.size);
                        }
                    };
                    video.src = URL.createObjectURL(file);
                } catch (e) {}
            });
    };

    const handleReplaceBroadcastRecording = (info) => {
        const fileObj = info?.file?.originFileObj || info?.file;
        const isMp4 = info?.file?.type === 'video/mp4' || info?.file?.name?.toLowerCase().endsWith('.mp4');
        updatepdf(fileObj);
        if (info?.file?.name) {
            setVideoFile(info.file.name);
        }
        if (fileObj?.size) {
            setFileSize(fileObj.size);
            extractFileInfo(fileObj);
        }
        const { status } = info.file;
        if (status !== 'uploading') {
            if (!isMp4) {
                Notification.error('Error', 'Only .mp4 files are allowed.');
                return;
            }
        }
        if (status === 'done') {
            Notification.success('Success', `${info.file.name} file uploaded successfully.`);
            if (fileObj) extractFileInfo(fileObj);
        } else if (status === 'error') {
            Notification.error('Error', `${info.file.name} file upload failed.`);
        }
    };

    // merge chunk and upload
    let fileId = null;
    const uploadFunction = async (uploadingMessage, callback, successCallback) => {
        fileId = uuidv4() + "." + Pdftoupload?.name?.split('.')?.pop();
        try {
            await uploadFileInChunks({
                file: Pdftoupload,
                chunkType: Pdftoupload?.type,
                uploadChunk: uploadBlock,
                onProgress: (percent) => setProgress(percent),
            });
            // Only merge once every block is up - uploadFileInChunks rejects otherwise.
            BroadcastMergeChunk(fileId, (key) => {
                if (uploadingMessage) {
                    uploadingMessage();
                }
                const finalSize = fileSize || Pdftoupload?.size;
                const finalDuration = duration || '00:00:00';
                const finalName = videoFile || Pdftoupload?.name;

                const uploadPayload = {
                    roomId: roomName,
                    fileSize: finalSize,
                    newFileName: finalName,
                    fileDuration: finalDuration
                };
                postBroadcastVideoUpload(uploadPayload, () => { setLoader(false); }, () => {
                    setIsUploadModal(false);
                    setVideoFile(null);
                    setFileSize(null);
                    setDuration(null);
                    saveReplacedRecording({
                        roomName,
                        scheduleId: cardData?.id || cardData?.scheduleId,
                        fileSize: finalSize,
                        fileDuration: finalDuration,
                        fileName: finalName
                    });
                    if (cardData && typeof setCardData === 'function') {
                        setCardData({
                            ...cardData,
                            fileSize: finalSize,
                            size: finalSize,
                            videoFileSize: finalSize,
                            fileDuration: finalDuration,
                            videoDuration: finalDuration,
                            duration: finalDuration,
                            recordingName: finalName
                        });
                    }
                    if (recordingsData && recordingsData.length > 0 && typeof setRecordingsData === 'function') {
                        const updated = recordingsData.map((rec, i) => {
                            if (i === 0) {
                                return {
                                    ...rec,
                                    fileSize: finalSize,
                                    duration: finalDuration,
                                    name: finalName
                                };
                            }
                            return rec;
                        });
                        setRecordingsData(updated);
                    }
                    EventRegister.emit('apicall:scheduleHome');
                    if (setRecordingsModalVisibility) {
                        setRecordingsModalVisibility(true);
                    }
                });
            });
        } catch (error) {
            console.log("error in block upload", error);
            Notification.error('Error', 'Upload failed. Please try again.');
            setLoader(false);
        }
    };

    const uploadBlock = async (currentBlock, orderId) => {
        var params = {
            file: currentBlock,
            orderId: orderId,
            fileName: fileId,
            roomName: roomName
        }
        const response = await uploadBroadcastBlock(params, () => { });
        if (response?.data?.progress?.message !== "uploaded") {
            throw new Error(`Block ${orderId} was not accepted by the server`);
        }
    }



    return (
        <>

            <Modal
                className="modal-round-corner"
                open={isUploadModal}
                footer={null}
                //centered={true}
                // width={"50%"}
                closable={false}
                bodyStyle={{ borderRadius: "10px" }}
                onCancel={() => handleCancel()}
            >
                <div>
                    <div className='lecturenotestitle' style={{ width: '100%', textAlign: 'center', padding: '0px' }}>
                        <p style={{ margin: '0px' }}> Upload content for Library</p>
                    </div>
                    {
                        isupload?
                        null:
                        <div>The current video will be replaced with a new one</div>
                    }
                    <div>
                        <Dragger
                        showUploadList={false}
                            customRequest={({ onSuccess }) => { setTimeout(() => onSuccess('ok'), 0); }}
                            onChange={(e) => { handleReplaceBroadcastRecording(e) }}
                            accept={".mp4"}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">
                                Support for a single  upload. Strictly prohibited from uploading company data or other
                                banned files.
                            </p>
                        </Dragger>
                    </div>
                    {videoFile ?
                        (<>
                            <div style={{ marginTop: '10px', width: "100%" }}>
                                <div className='shadow-box hover-shadow customCardShadow' style={{ height: "60px", padding: "10px" }}>
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <div >
                                            <img src={file_image_1} style={{ width: "40px", height: "40px" }} />
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "10px" }}>
                                            <div style={{ fontSize: "13px", fontWeight: "bold" }}>{videoFile}</div>
                                            <Tooltip placement="top" overlay="Remove file">
                                                <div style={{ borderColor: "#E6E6E6", color: "#AEAEAE", fontSize: "11px", fontWeight: "bold", cursor: "pointer", }} onClick={() => { setVideoFile(null),setFileSize(null),setDuration(null) }}>
                                                    <DeleteOutlined style={{ fontSize: "20px", color: "#FF414D" }} />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>) : null}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "30px",
                        }}
                    >
                        <div>
                            <Button
                                    onClick={handleCancel}
                                >
                                    CANCEL
                            </Button>
                        </div>
                        <div>
                            <Button
                            disabled={fileSize == null}
                                loading={loader}
                                style={{
                                    opacity:fileSize == null ? 0.5 : 1
                                }}
                                type='primary'
                                onClick={() => { handleOK() }}

                            >
                                UPLOAD
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>

        </>
    );
};

const mapStateToProps = (state) => {
    const {
        Pdftoupload,
        recordingsData
    } = state.broadcast;
    const { cardData } = state.schedule;
    const { user } = state.session;
    return {
        Pdftoupload,
        recordingsData,
        cardData
    };
};

const mapDispatchToProps = (dispatch) => ({
    uploadBroadcastBlock: (params, callback) => dispatch(uploadBroadcastBlock(params, callback)),
    BroadcastMergeChunk: (fileId, callback) => dispatch(BroadcastMergeChunk(fileId, callback)),
    fileKeyUpdate: (key) => dispatch(fileKeyUpdate(key)),
    updatepdf: (data) => dispatch(updatepdf(data)),
    setHideMsgTrue:(res) => dispatch(setHideMsgTrue(res)),
    postBroadcastVideoUpload: (params, callback, successCallback) => dispatch(postBroadcastVideoUpload(params, callback, successCallback)),
    deleteBroadcastRecording: (roomName, callback, succesCallback, suppressToast) => dispatch(deleteBroadcastRecording(roomName, callback, succesCallback, suppressToast)),
    setCardData: (val) => dispatch(setCardData(val)),
    setRecordingsData: (data) => dispatch(setRecordingsData(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(ReplaceVideos);